
<div class="tenants-payment-form" *ngIf="paymentInformation">
    <div class="link-generado" *ngIf="linkGenerado">
        <span class="section-title">Link de pago generado</span>
        <span class="section-description">Copie el link para enviarlo por el canal que prefiera.</span>
        <div class="link-generado-buttons">
            <button mat-raised-button color="primary" class="garantor-button mini" (click)="copyLink()">
                Copiar link
            </button>
            <button mat-raised-button color="accent" class="garantor-button mini" (click)="volver()">
                Volver
            </button>
        </div>
    </div>
    <ng-container *ngIf="!linkGenerado">
        <app-payment-form
            [payment]="paymentFG.value"
            (paymentChange)="paymentFG.patchValue($event)"
            [paymentInformation]="paymentInformation"
            [uploadPaymentProofFn]="uploadPaymentProof"
        ></app-payment-form>
        <div class="buttons">
            <button mat-raised-button color="primary" class="garantor-button informar-pago-button" (click)="pay()" *ngIf="paymentFG.value.opcion || paymentFG.value.medio" [disabled]="!paymentFG.valid">
                {{ paymentFG.value.medio === 'EFECTIVO' || paymentFG.value.medio === 'TRANSFERENCIA' ? 'Informar pago' : 'Pagar' }}
            </button>
        </div>
    </ng-container>
</div>
